module.exports = __webpack_public_path__ + "img/happytablet_info1.7884e092.jpg";